import { useGetSettings, getGetSettingsQueryKey } from "@workspace/api-client-react";

export function useSettingsFormat() {
  const { data: settings } = useGetSettings({
    query: { queryKey: getGetSettingsQueryKey() }
  });

  const currency = settings?.currencyLabel?.trim() || "USD";
  const timezone = settings?.timezone?.trim() || undefined;

  const formatCurrency = (value: number): string => {
    try {
      const formatted = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency,
        currencyDisplay: "narrowSymbol",
      }).format(value);
      // Strip 2–3-letter ISO prefix before a $ sign (e.g. "CA$" → "$")
      return formatted.replace(/^[A-Z]{2,3}\$/, "$");
    } catch {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(value);
    }
  };

  const formatDate = (
    dateValue: string | Date,
    options?: Intl.DateTimeFormatOptions
  ): string => {
    try {
      let date: Date;
      if (typeof dateValue === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
        const [y, m, d] = dateValue.split("-").map(Number);
        date = new Date(y, m - 1, d);
      } else {
        date = typeof dateValue === "string" ? new Date(dateValue) : dateValue;
      }
      const opts: Intl.DateTimeFormatOptions = options ?? {
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      if (timezone) {
        return new Intl.DateTimeFormat("en-US", {
          ...opts,
          timeZone: timezone,
        }).format(date);
      }
      return new Intl.DateTimeFormat("en-US", opts).format(date);
    } catch {
      const date =
        typeof dateValue === "string" ? new Date(dateValue) : dateValue;
      return date.toLocaleDateString("en-US");
    }
  };

  return { formatCurrency, formatDate, currency, timezone };
}
